export enum InputTransform {
  Uppercase = 'uppercase',
  Lowercase = 'lowercase',
  Trim = 'trim',
}

export const inputTransforms = {
  [InputTransform.Uppercase]: (value: string) => value.toUpperCase(),
  [InputTransform.Lowercase]: (value: string) => value.toLowerCase(),
  [InputTransform.Trim]: (value: string) => value.trim(),
} satisfies Record<InputTransform, (value: string) => string>;

export type InputTransformValue = InputTransform | ((value: string) => string);

export const resolveInputTransform = (
  transform: InputTransformValue,
): ((value: string) => string) =>
  typeof transform === 'function' ? transform : inputTransforms[transform];
